var _rect, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBecomeFeature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.644 52.2222C17.954 47.7212 15.9219 42.0369 15.9219 36.2167V20.1348C15.9219 19.7541 16.0731 19.3889 16.3423 19.1196L23.0415 12.4204C23.3108 12.1512 23.6759 12 24.0566 12H48.9395C49.3202 12 49.6854 12.1512 49.9546 12.4204L56.6538 19.1196C56.923 19.3889 57.0742 19.7541 57.0742 20.1348V36.2167C57.0742 42.037 55.0421 47.7212 51.3521 52.2222C47.6621 56.7232 42.4869 59.8307 36.7795 60.9722C36.5937 61.0093 36.4023 61.0093 36.2165 60.9722C30.5092 59.8307 25.334 56.7232 21.644 52.2222Z",
    fill: "url(#paint0_linear_31350_37949)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9114 21.4982L47.5758 18.1627C47.3067 17.8934 46.9415 17.7422 46.5608 17.7422H26.4352C26.0544 17.7422 25.6893 17.8934 25.4201 18.1626L22.0845 21.4982C21.8153 21.7674 21.6641 22.1325 21.6641 22.5133V36.2167C21.6641 45.0311 27.6114 52.7787 36.1269 55.0576C36.3701 55.1227 36.626 55.1227 36.8692 55.0576C45.3846 52.7787 51.3319 45.0311 51.3319 36.2167V22.5133C51.3319 22.1326 51.1807 21.7675 50.9114 21.4982ZM43.7727 30.9597L34.2986 40.4338C33.738 40.9944 32.8291 40.9944 32.2684 40.4338L29.2233 37.3885C28.6626 36.8279 28.6626 35.919 29.2233 35.3584C29.7839 34.7977 30.6928 34.7977 31.2534 35.3584L33.2836 37.3885L41.7426 28.9295C42.3032 28.3689 43.2121 28.3689 43.7727 28.9295C44.3333 29.4901 44.3333 30.399 43.7727 30.9597Z",
    fill: "url(#paint1_linear_31350_37949)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31350_37949",
    x1: 15.9219,
    y1: 36.5,
    x2: 57.0742,
    y2: 36.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B71F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FB5F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_31350_37949",
    x1: 21.6641,
    y1: 36.4243,
    x2: 51.3319,
    y2: 36.4243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1CBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBE2FD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBecomeFeature);
export default __webpack_public_path__ + "static/media/become-feature.0c1aacc9331a8a8d0e37a4c62e420dab.svg";
export { ForwardRef as ReactComponent };